import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

export const SelectInput = ({label, id, requested, options, value, setValue}) => {


    const handelChanges = (inputValue) => {
        setValue(inputValue);
    }

    return (
        <div className={"flex flex-col justify-center max-h-[400px] max-w-[500px] w-full"}>
            <h4 className="font-semibold text-sm mb-0 lg:mb-1 text-gray-900">
                {label}<span className='ml-1 text-sm font-light text-indigo-900 text-xs'>{requested ? '(Pflichtfeld)' : ''}</span>
            </h4>
            <label htmlFor={id} className="sr-only">
                {label}
            </label>
            <div className="w-full">
                <Select
                    className={`text-gray-900 w-full truncate ring-0 ring-gray-300 p-0 text-sm`}
                    style={{display:"grid", paddingRight:"14px"}}
                    size="small"
                    required={requested}
                    labelId={id}
                    id={id}
                    value={value}
                    name={id}
                    onChange={(e) => {
                        handelChanges(e.target.value)
                    }}
                    variant={"outlined"}
                    displayEmpty
                >
                    <MenuItem value="">
                        <em>----</em>
                    </MenuItem>
                    {options.map((option) => (
                        <MenuItem className="truncate" value={option.id} key={option.id}>{option.name}</MenuItem>
                    ))}
                </Select>
            </div>
        </div>
    )
}
